import messages from '../messages/sk';

export default {
    locale: 'sk',
    messages
};